// extracted by mini-css-extract-plugin
export default {"wrapper":"UserAvatar_wrapper__b3xDs","avatar":"UserAvatar_avatar__rnQD8","userLink":"UserAvatar_userLink__mqoAL"};